
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('circle',{attrs:{"cx":"256","cy":"256","r":"256"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"#fecb00","d":"M0 0h512v170.7H0z"}}),_c('path',{attrs:{"fill":"#33b13a","d":"M0 170.7h512v170.7H0z"}}),_c('path',{attrs:{"fill":"#f13637","d":"M0 341.4h512v170.7H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M256 92.5l40 123h129.2l-104.6 76 40 123-104.6-76-104.6 76 40-123-104.6-76H216z"}})])])
          )
        }
      }
    